import { render, staticRenderFns } from "./HoldContactSettingTable.vue?vue&type=template&id=0db943e6&scoped=true&"
import script from "./HoldContactSettingTable.vue?vue&type=script&lang=js&"
export * from "./HoldContactSettingTable.vue?vue&type=script&lang=js&"
import style0 from "./HoldContactSettingTable.vue?vue&type=style&index=0&id=0db943e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db943e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VIcon,VSimpleTable,VTextField})
